import {
  CREATE_MESSAGE,
  CREATE_MESSAGE_ERR,
  CREATE_MESSAGE_OK,
  DO_MESSAGES_CLEANUP,

  GET_MESSAGES,
  GET_MESSAGES_ERR,
  GET_MESSAGES_OK
} from "./actionTypes";
import { GetMessagesResponse, SendMessageRequest } from "~/types/backend";

export const getMessages = (channelId: string, params?: any) => ({
  type: GET_MESSAGES,
  payload: { channelId, params },
});

export const getMessagesOk = (response: GetMessagesResponse, channelId: number) => ({
  type: GET_MESSAGES_OK,
  payload: { response, channelId },
});

export const getMessagesErr = (error: Error) => ({
  type: GET_MESSAGES_ERR,
  payload: { error },
});

export const doMessagesCleanup = () => ({
  type: DO_MESSAGES_CLEANUP,
});

export const createMessage = (data: FormData | SendMessageRequest) => ({
  type: CREATE_MESSAGE,
  payload: { data }
});

export const createMessageOk = () => ({
  type: CREATE_MESSAGE_OK,
});

export const createMessageErr = (error: Error) => ({
  type: CREATE_MESSAGE_ERR,
  payload: { error }
});